import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { ObjectStoreDetails } from "./components/ObjectStoreDetails";

export function ObjectStorePage() {
  return (
    <Page title="Object Store Details">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <ObjectStoreDetails />
      </Container>
    </Page>
  );
}
